export default [
  {
    title: `Can I access the database from different computers?`,
    description: `Yes! Every workspace has a local copy on your file system. As long as the folder that contains the workspace is accessible by a computer, it can be accessed. However, two instances of the app can't access the same local workspace simultaneously. Only Team Workspaces can be accessed by multiple users at the same time.`
  },
  {
    title: `Can it be used by multiple users at the same time?`,
    description: `Yes! The TEAM plan allows that. Members of the team don't need to be subscribed to a plan but they are required to have an account on BOMIST.`
  },
  {
    title: `Can I use BOMIST offline?`,
    description: `Yes! BOMIST is an offline-first app, meaning you can use it offline. Team workspaces however can only be modified while online to avoid syncing problems. Plan subscriptions also need to be validated from time to time, which requires an internet connection. However, BOMIST allows you to stay offline for a maximum of 15 days after your last successful login. When offline, features that depend on an internet connection (e.g. up-to-date pricing and availability), might not be available (if not cached).`
  },
  {
    title: `How many Team Workspaces do I get with the TEAM plan?`,
    description: `Every TEAM subscription gives you access to a single Team Workspace. Discounts are available if you need more than one though (please reach out to learn more).`
  },
  {
    title: 'How many team members can I have in a Team Workspace?',
    description: `Every Team Workspace can have as many team members as needed, at no additional cost.`
  },
  {
    title: `When downgrading from a paid plan, do I lose my data?`,
    description: `No data is lost, ever, when downgrading from any paid plan. When you downgrade from a paid plan, you just lose the paid features that come with it. Even though some data might not be visible in the FREE version, if you decide to upgrade to a paid version later, that data will be visible again.`
  },
  {
    title: `If I cancel a subscription, do I get a refund?`,
    description: `All paid plans come with a 30-day money back guarantee. If you pass the trial period and have a subscription for less than 30 days, you are entitled to a full refund. If those conditions are not verified, no refund will take place.`
  },
  {
    title: `When cancelling a subscription, do I lose paid features immediately?`,
    description: `No. The cancellation will only take place at the end of the billing period.`
  },
  {
    title: `When changing between paid plans in the middle of a billing period, do I lose money?`,
    description: `No. You'll be credited for the unused time and only pay the difference according to your new plan and billing settings.`
  },
  {
    title: `Do you have a free trial?`,
    description: `Yes! To get a 14-day trial of the PRO plan all you need to do is to sign-up. No credit card needed upfront. If you are looking for a trial of the TEAM plan, please get in touch.`
  },
  {
    title: `Can I "pay-as-you-go"?`,
    description: `BOMIST is subscription-based. However, you can pay for paid features only during the months you need them with a monthly subscription and by cancelling the subscription as soon as you don’t need them. Definitive cancellation only takes place at the end of the billing period.`
  }
];
